import React, { useState, useEffect } from "react"
import { Button, Input, Label } from "reactstrap"
import { UpdateLOBStart} from "store/SuperAdmin/Lob-SubLob-company-income/action"
import { useDispatch, useSelector } from "react-redux"

const CreateLob = ({ updateData }) => {
  const dispatch = useDispatch()
  const [data, setData] = useState({
    id: "",
    insurance_id: "",
    lob: "",
    color_code: "",
  })

  const handleChange = e => {
    const { name, value } = e.target
    setData(prev => ({
      ...prev,
      [name]: value,
    }))
  }

  const handleSubmit = e => {
    e.preventDefault()
    dispatch(UpdateLOBStart(data))
  }

  useEffect(() => {
    if (updateData && updateData.length > 0) {
      const Lobs = updateData[0];
      setData({
        id: Lobs.id || "",
        insurance_id: Lobs.insurancetype_id || "",
        lob: Lobs.LOB || "",
        color_code: Lobs.color_code || "",
      });
    }
  }, [updateData]);


  return (
    <>
      <Label>Insurance Type</Label>
      <span className="text-danger">*</span>
      <select
        className="form-select"
        aria-label="Default select example"
        name="insurance_id"
        value={data.insurance_id}
        onChange={handleChange}
      >
        <option value="">Select Insurance Type</option>
        <option value={1}>General Insurance</option>
        <option value={2}>Life Insurance</option>
      </select>

      <Label className="mt-3">LOB</Label>
      <span className="text-danger">*</span>
      <Input
        name="lob"
        placeholder="Enter LOB"
        value={data.lob}
        onChange={handleChange}
      />

      <Label className="mt-3">Color code</Label>
      <span className="text-danger">*</span>
      <Input
        name="color_code"
        placeholder="eg. #ACDDDE"
        value={data.color_code}
        onChange={handleChange}
      />

      <Button
        type="submit"
        className="btn btn-dark mt-4"
        onClick={handleSubmit}
      >
        Submit
      </Button>
    </>
  )
}

export default CreateLob
